import { motion } from "framer-motion";
import { useEffect, useState, useCallback } from "react";
import { BurgerCustom } from "../ui/header/BurgerCustom";
import { NavbarCustom } from "../ui/header/NavbarCustom";
import { Container } from "../ui/atoms/Container";
import useMobile from "../hooks/useMobile";
import { useNavbar } from "../hooks/useNavbar";
import { Brand } from "../ui/header/Brand";

export const Header = ({ scrollHeader }) => {
  
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const { isMobile } = useMobile();
  
  const { context: { isOpen, setIsOpen } } = useNavbar();

  // Header when scrolling
  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;

    if (!scrollHeader) return;

    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // Scroll Down
      setIsVisible(false);
    } else {
      // Scroll Up
      setIsVisible(true);
    }

    setLastScrollY(currentScrollY);
  }, [lastScrollY, scrollHeader]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <motion.header
      className={`flex h-20 items-center justify-center fixed top-0 left-0 w-full z-50`}
      initial={{ opacity:0, translateY: isVisible ? 0 : 150 }}
      animate={{ opacity:isVisible ? 1 : 0, translateY: isVisible ? 0 : -150 }}
      transition={{ type:"spring", stiffness:200, damping:50, ease: "easeInOut" }}
    >
      <Container className="flex items-center justify-between">
        <Brand setIsOpen={setIsOpen} isOpen={isOpen} />
        <BurgerCustom setIsOpen={setIsOpen} isOpen={isOpen} />
        <NavbarCustom isOpen={isOpen} isMobile={isMobile} setIsOpen={setIsOpen}/>
      </Container>
    
    </motion.header>
  );
};
